import { connect, useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateNotificationPriority,
  getNotifications,
} from "../../../../action/masters/notificationActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
  sortAlphabetically,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateNotificationPriority,
  INotificationData,
} from "../../../../models/master/notification";
import { setNotifications } from "../../../../store/slices/master/notificationSlice";
import LoaderSpinner from "../../../../common-components/loader";
import {
  getColleges,
  getDepartments,
} from "../../../../action/common/commonActionCreator";
import FloatingLabelDropDown from "../../../../common-components/floatingdropdown";
import { UserRole } from "../../../../constants/RoleEnum";
import {
  setColleges,
  setDepartments,
} from "../../../../store/slices/common/commonSlice";

const PriorityNotifications = (props: IUpdateNotificationPriority) => {
  const {
    updateNotificationPriority,
    getNotifications,
    notifications,
    configUserRole,
    currentRole,
    departments,
    colleges,
    getColleges,
    getDepartments,
    currentCollege,
    currentDepartment,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [selectedCollege, setSelectedCollege] = useState<any>(null);
  const [selectedDepartments, setSelectedDepartments] = useState<any>(null);
  const dispatch = useDispatch();

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateNotificationPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);

    setfilteredItems([..._items]);
    updateNotificationPriority(_items, setAlert);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllNotifications = async (
    configUserRoleId: number,
    departmentId?: number,
    collegeId?: number
  ) => {
    setLoader(true);
    try {
      await getNotifications(configUserRoleId, departmentId, collegeId);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (currentRole === UserRole.SuperAdmin) {
      getColleges && getColleges();
    }
    return () => {
      dispatch(setNotifications([]));
      dispatch(setColleges([]));
      dispatch(setDepartments([]));
    };
  }, []);

  useEffect(() => {
    if (
      currentRole === UserRole.SuperAdmin &&
      colleges &&
      colleges?.length > 0
    ) {
      const defaultCollegeId = colleges[0]?.id;
      setSelectedCollege(defaultCollegeId);
      getDepartments && getDepartments(defaultCollegeId);
    } else if (currentRole === UserRole.CollegeAdmin && currentCollege) {
      setSelectedCollege(currentCollege);
      getDepartments && getDepartments(currentCollege);
    } else if (
      currentRole === UserRole.DepartmentAdmin &&
      currentCollege &&
      currentDepartment
    ) {
      setSelectedCollege(currentCollege);
      setSelectedDepartments(currentDepartment);
    }
  }, [colleges, currentRole, currentCollege, currentDepartment]);

  useEffect(() => {
    if (
      departments &&
      departments.length > 0 &&
      selectedCollege &&
      (currentRole === UserRole.SuperAdmin ||
        currentRole === UserRole.CollegeAdmin)
    ) {
      const firstDeptId = departments[0].id;
      if (selectedDepartments !== firstDeptId) {
        setSelectedDepartments(firstDeptId);
      }
    }
  }, [departments, selectedCollege]);

  useEffect(() => {
    if (selectedCollege && selectedDepartments) {
      getAllNotifications(configUserRole, selectedDepartments, selectedCollege);
    }
  }, [selectedCollege, selectedDepartments, configUserRole]);

  useEffect(() => {
    if (notifications?.notifications) {
      setfilteredItems(cloneDeep(notifications.notifications));
    } else {
      setfilteredItems([]);
    }
  }, [notifications]);

  const onSelectionChange = useCallback((e: any) => {
    if (e.target.name === "College") {
      const newCollegeId = e.target.value;
      setSelectedCollege(newCollegeId);
      setSelectedDepartments(null);
      setfilteredItems([]);
      dispatch(setNotifications([]));
      dispatch(setDepartments([]));
      getDepartments && getDepartments(newCollegeId);
    } else if (e.target.name === "Departments") {
      setSelectedDepartments(e.target.value);
    }
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Notifications</h2>
          <div className="side-filter d-flex justify-content-end w-50">
            {(currentRole == UserRole.SuperAdmin ||
              currentRole == UserRole.CollegeAdmin) && (
              <>
                {currentRole === UserRole.SuperAdmin && (
                  <div className="col-md-6">
                    <FloatingLabelDropDown
                      label="University Management"
                      placeholder=""
                      onChange={(e: any) => onSelectionChange(e)}
                      isMandatory={false}
                      value={selectedCollege}
                      name="College"
                      optionsList={sortAlphabetically(colleges)}
                      showClear={false}
                    />
                  </div>
                )}
                <div className="col-md-6">
                  <FloatingLabelDropDown
                    label="Departments"
                    placeholder=""
                    onChange={(e: any) => onSelectionChange(e)}
                    isMandatory={false}
                    value={selectedDepartments}
                    name="Departments"
                    optionsList={sortAlphabetically(departments)}
                    showClear={false}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner />
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: INotificationData) => item.displayOrNot)
                  .map((notification: INotificationData, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{notification.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={notification.displayOrNot}
                            id={notification.priority + "notification"}
                            onChange={() => {
                              ChangeVisibleOrNot(
                                notification.id ?? 0,
                                !notification.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={notification.priority + "notification"}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <h3>{notification.notificationTypeName}</h3>
                        <div className="img">
                          <img
                            src={
                              notification.image
                                ? baseURL + notification.image
                                : "/assets/images/icon/graduation.svg"
                            }
                            onError={(e) => {
                              e.currentTarget.src =
                                "/assets/images/icon/graduation.svg";
                            }}
                            alt=""
                          />
                        </div>
                        <h2>{notification.title}</h2>
                        <p className="text-wrap">
                          {notification.notificationMessage}
                        </p>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: INotificationData) => !item.displayOrNot)
                .map((notification: INotificationData, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={notification.displayOrNot}
                          id={notification.priority + "notification"}
                          onChange={() => {
                            ChangeVisibleOrNot(
                              notification.id ?? 0,
                              !notification.displayOrNot
                            );
                          }}
                        />
                        <label
                          htmlFor={notification.priority + "notification"}
                        ></label>
                      </div>
                    </div>
                    <div className="btm">
                      <h3>{notification.notificationTypeName}</h3>
                      <div className="img">
                        <img
                          src={
                            notification.image
                              ? baseURL + notification.image
                              : "/assets/images/icon/graduation.svg"
                          }
                          onError={(e) => {
                            e.currentTarget.src =
                              "/assets/images/icon/graduation.svg";
                          }}
                          alt=""
                        />
                      </div>
                      <h2>{notification.title}</h2>
                      <p>{notification.notificationMessage}</p>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateNotificationPriority: (data: any, callBack: Function) =>
    updateNotificationPriority(data, callBack),
  getNotifications: (
    configUserRole: number,
    departmentId?: number,
    collegeId?: number
  ) => getNotifications(configUserRole, undefined, departmentId, collegeId),
  getColleges: () => getColleges(),
  getDepartments: (collegeId?: number) => getDepartments(collegeId),
};

function mapStateToProps(state: any) {
  return {
    notifications: state.notification.notifications,
    colleges: state.common.colleges,
    departments: state.common.departments,
    currentRole: state.userDetails.userProfileData?.currentRole,
    currentCollege: state.userDetails.userProfileData?.currentCollege?.id,
    currentDepartment: state.userDetails.userProfileData?.currentDepartment?.id,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityNotifications);
